import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/api/auth.service';
import { map } from 'rxjs';

export const isAuthenticatedGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);

    return inject(AuthService).isAuthenticated$.pipe(
        map(isLoggedIn => {
            if (isLoggedIn) {
                return true;
            } else {
                return router.createUrlTree(['/auth/login']);
            }
        })
    );
};
